// extracted by mini-css-extract-plugin
export var linkButton = "linkButton-module--linkButton--a966b";
export var onFile = "linkButton-module--onFile--b34ad";